import { AccountFeature, isAccountFeatureEnabled } from 'hooks/use-account-feature';
import { isTauriApp } from 'utils/is-tauri';
export const APP_SHELL_MODE_STORAGE_KEY = 'app-shell-mode';
export const DEFAULT_APP_SHELL_MODE = 'rocketlane';
const isAppShellMode = (value)=>value === 'rocketlane' || value === 'nitro-claw';
export const isNitroClawPathname = (pathname)=>{
    const normalized = pathname.startsWith('/') ? pathname : `/${pathname}`;
    return normalized === '/nitro-claw' || normalized.startsWith('/nitro-claw/');
};
export const getAppShellMode = ()=>{
    if (typeof window === 'undefined') {
        return DEFAULT_APP_SHELL_MODE;
    }
    try {
        const raw = window.localStorage.getItem(APP_SHELL_MODE_STORAGE_KEY);
        if (raw == null) {
            return DEFAULT_APP_SHELL_MODE;
        }
        const parsed = JSON.parse(raw);
        return isAppShellMode(parsed) ? parsed : DEFAULT_APP_SHELL_MODE;
    } catch (unused) {
        return DEFAULT_APP_SHELL_MODE;
    }
};
export const persistAppShellMode = (mode)=>{
    if (typeof window === 'undefined') {
        return;
    }
    try {
        window.localStorage.setItem(APP_SHELL_MODE_STORAGE_KEY, JSON.stringify(mode));
    } catch (unused) {}
};
export const isNitroClawShell = ()=>{
    if (!isAccountFeatureEnabled(AccountFeature.NitroClaw)) {
        return false;
    }
    return isTauriApp() || getAppShellMode() === 'nitro-claw';
};
